/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * Generated by orval v7.6.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import type {
  GenderDTO,
  GetGendersParams,
  GetGendersServerParams,
  GetLanguagesParams,
  GetLanguagesServerParams,
  GetTitlesParams,
  GetTitlesServerParams,
  LanguageDTO,
  TitleDTO,
} from '@as-react/common-types/customer-service';
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryFetch } from '../../utils/orval/queryFetch';
import { queryKeyMutator } from '../../utils/orval/queryKeyMutator';
import { useQueryFetch } from '../../utils/orval/useQueryFetch';
import type { ErrorType } from '../../utils/orval/useQueryFetch';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Search for all titles in a market
 * @summary Determining the market to search in can be done by either providing the id of the market or the name of the mainwebshop.
 */
export const useGetTitlesHook = () => {
  const getTitles = useQueryFetch<Array<TitleDTO>>();

  return useCallback(
    (
      params?: GetTitlesParams,
      operationName = 'getTitles',
      options?: SecondParameter<ReturnType<typeof useQueryFetch>>,
      signal?: AbortSignal
    ) => {
      return getTitles(
        { url: `/api/aem/general/title/all`, method: 'GET', params, signal },
        { operationName: 'getTitles', ...options }
      );
    },
    [getTitles]
  );
};

export const useGetTitlesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetTitlesHook>>>,
  TError = ErrorType<Array<TitleDTO>>,
>(
  params?: GetTitlesParams,
  operationName = 'getTitles',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTitlesHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator({ params, operationName }, { url: `/api/aem/general/title/all`, queryOptions });

  const getTitles = useGetTitlesHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTitlesHook>>>> = ({ signal }) =>
    getTitles(params, operationName, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetTitlesHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTitlesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetTitlesHook>>>>;
export type GetTitlesQueryError = ErrorType<Array<TitleDTO>>;

export function useGetTitles<
  TData = Awaited<ReturnType<ReturnType<typeof useGetTitlesHook>>>,
  TError = ErrorType<Array<TitleDTO>>,
>(
  params: undefined | GetTitlesParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTitlesHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTitlesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetTitlesHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTitles<
  TData = Awaited<ReturnType<ReturnType<typeof useGetTitlesHook>>>,
  TError = ErrorType<Array<TitleDTO>>,
>(
  params?: GetTitlesParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTitlesHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTitlesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetTitlesHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTitles<
  TData = Awaited<ReturnType<ReturnType<typeof useGetTitlesHook>>>,
  TError = ErrorType<Array<TitleDTO>>,
>(
  params?: GetTitlesParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTitlesHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Determining the market to search in can be done by either providing the id of the market or the name of the mainwebshop.
 */

export function useGetTitles<
  TData = Awaited<ReturnType<ReturnType<typeof useGetTitlesHook>>>,
  TError = ErrorType<Array<TitleDTO>>,
>(
  params?: GetTitlesParams,
  operationName = 'getTitles',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTitlesHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetTitlesQueryOptions(params, operationName, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Search for all titles in a market
 * @summary Determining the market to search in can be done by either providing the id of the market or the name of the mainwebshop.
 */
export const getTitlesServer = (
  params?: GetTitlesServerParams,
  operationName = 'getTitles',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<Array<TitleDTO>>(
    { url: `/masterdata/title/all`, method: 'GET', params, signal },
    { operationName: 'getTitles', service: 'customer-service', ...options }
  );
};

export const useGetTitlesServerQueryOptions = <
  TData = Awaited<ReturnType<typeof getTitlesServer>>,
  TError = ErrorType<Array<TitleDTO>>,
>(
  params?: GetTitlesServerParams,
  operationName = 'getTitles',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTitlesServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator({ params, operationName }, { url: `/masterdata/title/all`, queryOptions });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTitlesServer>>> = ({ signal }) =>
    getTitlesServer(params, operationName, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTitlesServer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTitlesServerQueryResult = NonNullable<Awaited<ReturnType<typeof getTitlesServer>>>;
export type GetTitlesServerQueryError = ErrorType<Array<TitleDTO>>;

export function useGetTitlesServer<
  TData = Awaited<ReturnType<typeof getTitlesServer>>,
  TError = ErrorType<Array<TitleDTO>>,
>(
  params: undefined | GetTitlesServerParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTitlesServer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTitlesServer>>,
          TError,
          Awaited<ReturnType<typeof getTitlesServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTitlesServer<
  TData = Awaited<ReturnType<typeof getTitlesServer>>,
  TError = ErrorType<Array<TitleDTO>>,
>(
  params?: GetTitlesServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTitlesServer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTitlesServer>>,
          TError,
          Awaited<ReturnType<typeof getTitlesServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTitlesServer<
  TData = Awaited<ReturnType<typeof getTitlesServer>>,
  TError = ErrorType<Array<TitleDTO>>,
>(
  params?: GetTitlesServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTitlesServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Determining the market to search in can be done by either providing the id of the market or the name of the mainwebshop.
 */

export function useGetTitlesServer<
  TData = Awaited<ReturnType<typeof getTitlesServer>>,
  TError = ErrorType<Array<TitleDTO>>,
>(
  params?: GetTitlesServerParams,
  operationName = 'getTitles',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTitlesServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetTitlesServerQueryOptions(params, operationName, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Search for all languages in a market
 * @summary Determining the market to search in can be done by either providing the id of the market or the name of the mainwebshop.
 */
export const useGetLanguagesHook = () => {
  const getLanguages = useQueryFetch<Array<LanguageDTO>>();

  return useCallback(
    (
      params?: GetLanguagesParams,
      operationName = 'getLanguages',
      options?: SecondParameter<ReturnType<typeof useQueryFetch>>,
      signal?: AbortSignal
    ) => {
      return getLanguages(
        { url: `/api/aem/general/language/all`, method: 'GET', params, signal },
        { operationName: 'getLanguages', ...options }
      );
    },
    [getLanguages]
  );
};

export const useGetLanguagesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetLanguagesHook>>>,
  TError = ErrorType<Array<LanguageDTO>>,
>(
  params?: GetLanguagesParams,
  operationName = 'getLanguages',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLanguagesHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator({ params, operationName }, { url: `/api/aem/general/language/all`, queryOptions });

  const getLanguages = useGetLanguagesHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetLanguagesHook>>>> = ({ signal }) =>
    getLanguages(params, operationName, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetLanguagesHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetLanguagesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetLanguagesHook>>>>;
export type GetLanguagesQueryError = ErrorType<Array<LanguageDTO>>;

export function useGetLanguages<
  TData = Awaited<ReturnType<ReturnType<typeof useGetLanguagesHook>>>,
  TError = ErrorType<Array<LanguageDTO>>,
>(
  params: undefined | GetLanguagesParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLanguagesHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetLanguagesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetLanguagesHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetLanguages<
  TData = Awaited<ReturnType<ReturnType<typeof useGetLanguagesHook>>>,
  TError = ErrorType<Array<LanguageDTO>>,
>(
  params?: GetLanguagesParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLanguagesHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetLanguagesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetLanguagesHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetLanguages<
  TData = Awaited<ReturnType<ReturnType<typeof useGetLanguagesHook>>>,
  TError = ErrorType<Array<LanguageDTO>>,
>(
  params?: GetLanguagesParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLanguagesHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Determining the market to search in can be done by either providing the id of the market or the name of the mainwebshop.
 */

export function useGetLanguages<
  TData = Awaited<ReturnType<ReturnType<typeof useGetLanguagesHook>>>,
  TError = ErrorType<Array<LanguageDTO>>,
>(
  params?: GetLanguagesParams,
  operationName = 'getLanguages',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLanguagesHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetLanguagesQueryOptions(params, operationName, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Search for all languages in a market
 * @summary Determining the market to search in can be done by either providing the id of the market or the name of the mainwebshop.
 */
export const getLanguagesServer = (
  params?: GetLanguagesServerParams,
  operationName = 'getLanguages',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<Array<LanguageDTO>>(
    { url: `/masterdata/language/all`, method: 'GET', params, signal },
    { operationName: 'getLanguages', service: 'customer-service', ...options }
  );
};

export const useGetLanguagesServerQueryOptions = <
  TData = Awaited<ReturnType<typeof getLanguagesServer>>,
  TError = ErrorType<Array<LanguageDTO>>,
>(
  params?: GetLanguagesServerParams,
  operationName = 'getLanguages',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLanguagesServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator({ params, operationName }, { url: `/masterdata/language/all`, queryOptions });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLanguagesServer>>> = ({ signal }) =>
    getLanguagesServer(params, operationName, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLanguagesServer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetLanguagesServerQueryResult = NonNullable<Awaited<ReturnType<typeof getLanguagesServer>>>;
export type GetLanguagesServerQueryError = ErrorType<Array<LanguageDTO>>;

export function useGetLanguagesServer<
  TData = Awaited<ReturnType<typeof getLanguagesServer>>,
  TError = ErrorType<Array<LanguageDTO>>,
>(
  params: undefined | GetLanguagesServerParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLanguagesServer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLanguagesServer>>,
          TError,
          Awaited<ReturnType<typeof getLanguagesServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetLanguagesServer<
  TData = Awaited<ReturnType<typeof getLanguagesServer>>,
  TError = ErrorType<Array<LanguageDTO>>,
>(
  params?: GetLanguagesServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLanguagesServer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLanguagesServer>>,
          TError,
          Awaited<ReturnType<typeof getLanguagesServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetLanguagesServer<
  TData = Awaited<ReturnType<typeof getLanguagesServer>>,
  TError = ErrorType<Array<LanguageDTO>>,
>(
  params?: GetLanguagesServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLanguagesServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Determining the market to search in can be done by either providing the id of the market or the name of the mainwebshop.
 */

export function useGetLanguagesServer<
  TData = Awaited<ReturnType<typeof getLanguagesServer>>,
  TError = ErrorType<Array<LanguageDTO>>,
>(
  params?: GetLanguagesServerParams,
  operationName = 'getLanguages',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLanguagesServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetLanguagesServerQueryOptions(params, operationName, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Search for all genders in a market
 * @summary Determining the market to search in can be done by either providing the id of the market or the name of the mainwebshop.
 */
export const useGetGendersHook = () => {
  const getGenders = useQueryFetch<Array<GenderDTO>>();

  return useCallback(
    (
      params?: GetGendersParams,
      operationName = 'getGenders',
      options?: SecondParameter<ReturnType<typeof useQueryFetch>>,
      signal?: AbortSignal
    ) => {
      return getGenders(
        { url: `/api/aem/general/gender/all`, method: 'GET', params, signal },
        { operationName: 'getGenders', ...options }
      );
    },
    [getGenders]
  );
};

export const useGetGendersQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetGendersHook>>>,
  TError = ErrorType<Array<GenderDTO>>,
>(
  params?: GetGendersParams,
  operationName = 'getGenders',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetGendersHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator({ params, operationName }, { url: `/api/aem/general/gender/all`, queryOptions });

  const getGenders = useGetGendersHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetGendersHook>>>> = ({ signal }) =>
    getGenders(params, operationName, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetGendersHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetGendersQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetGendersHook>>>>;
export type GetGendersQueryError = ErrorType<Array<GenderDTO>>;

export function useGetGenders<
  TData = Awaited<ReturnType<ReturnType<typeof useGetGendersHook>>>,
  TError = ErrorType<Array<GenderDTO>>,
>(
  params: undefined | GetGendersParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetGendersHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetGendersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetGendersHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetGenders<
  TData = Awaited<ReturnType<ReturnType<typeof useGetGendersHook>>>,
  TError = ErrorType<Array<GenderDTO>>,
>(
  params?: GetGendersParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetGendersHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetGendersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetGendersHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetGenders<
  TData = Awaited<ReturnType<ReturnType<typeof useGetGendersHook>>>,
  TError = ErrorType<Array<GenderDTO>>,
>(
  params?: GetGendersParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetGendersHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Determining the market to search in can be done by either providing the id of the market or the name of the mainwebshop.
 */

export function useGetGenders<
  TData = Awaited<ReturnType<ReturnType<typeof useGetGendersHook>>>,
  TError = ErrorType<Array<GenderDTO>>,
>(
  params?: GetGendersParams,
  operationName = 'getGenders',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetGendersHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetGendersQueryOptions(params, operationName, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Search for all genders in a market
 * @summary Determining the market to search in can be done by either providing the id of the market or the name of the mainwebshop.
 */
export const getGendersServer = (
  params?: GetGendersServerParams,
  operationName = 'getGenders',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<Array<GenderDTO>>(
    { url: `/masterdata/gender/all`, method: 'GET', params, signal },
    { operationName: 'getGenders', service: 'customer-service', ...options }
  );
};

export const useGetGendersServerQueryOptions = <
  TData = Awaited<ReturnType<typeof getGendersServer>>,
  TError = ErrorType<Array<GenderDTO>>,
>(
  params?: GetGendersServerParams,
  operationName = 'getGenders',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGendersServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator({ params, operationName }, { url: `/masterdata/gender/all`, queryOptions });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGendersServer>>> = ({ signal }) =>
    getGendersServer(params, operationName, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGendersServer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetGendersServerQueryResult = NonNullable<Awaited<ReturnType<typeof getGendersServer>>>;
export type GetGendersServerQueryError = ErrorType<Array<GenderDTO>>;

export function useGetGendersServer<
  TData = Awaited<ReturnType<typeof getGendersServer>>,
  TError = ErrorType<Array<GenderDTO>>,
>(
  params: undefined | GetGendersServerParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGendersServer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGendersServer>>,
          TError,
          Awaited<ReturnType<typeof getGendersServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetGendersServer<
  TData = Awaited<ReturnType<typeof getGendersServer>>,
  TError = ErrorType<Array<GenderDTO>>,
>(
  params?: GetGendersServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGendersServer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGendersServer>>,
          TError,
          Awaited<ReturnType<typeof getGendersServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetGendersServer<
  TData = Awaited<ReturnType<typeof getGendersServer>>,
  TError = ErrorType<Array<GenderDTO>>,
>(
  params?: GetGendersServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGendersServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Determining the market to search in can be done by either providing the id of the market or the name of the mainwebshop.
 */

export function useGetGendersServer<
  TData = Awaited<ReturnType<typeof getGendersServer>>,
  TError = ErrorType<Array<GenderDTO>>,
>(
  params?: GetGendersServerParams,
  operationName = 'getGenders',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGendersServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetGendersServerQueryOptions(params, operationName, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
